module.exports = __webpack_public_path__ + "media/images/admin/icons/plus-887d2aad484110b1f963a4231aa8b89d.svg";